import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherInfo } from '@subframe/core';
import { Alert, Button } from '@/shared/components/ui';
import type { FaixaDaExecucaoProps } from '../types';

/**
 * O que o teste roda, lido da execução (CA-12), e os avisos dos dois modos: o não salvo não entra
 * (CA-13), o fluxo sem agente roda a definição salva nos dois (decisão provisória 3) e a
 * configuração salva depois do início pede Reiniciar (CA-14, decisão provisória 4).
 */
export const FaixaDaExecucao = t0 => {
  const $ = _c(13);
  const {
    identificacao,
    fluxoSemAgente,
    configuracaoAlterada,
    reiniciarDesabilitado,
    onReiniciar
  } = t0;
  let t1;
  if ($[0] !== identificacao) {
    t1 = identificacao && <Alert role="status" aria-label={"Configura\xE7\xE3o em teste"} variant="brand" icon={<FeatherInfo />} title="Em teste" description={identificacao} />;
    $[0] = identificacao;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== configuracaoAlterada || $[3] !== onReiniciar || $[4] !== reiniciarDesabilitado) {
    t2 = configuracaoAlterada && <Alert role="alert" variant="warning" tone="filled" icon={<FeatherAlertTriangle />} title={"A configura\xE7\xE3o foi salva depois do in\xEDcio do teste"} description={"Reinicie para testar a configura\xE7\xE3o salva agora. A conversa atual n\xE3o muda."} actions={<Button size="small" disabled={reiniciarDesabilitado} onClick={onReiniciar}>Reiniciar</Button>} />;
    $[2] = configuracaoAlterada;
    $[3] = onReiniciar;
    $[4] = reiniciarDesabilitado;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherInfo />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = fluxoSemAgente ? "Altera\xE7\xF5es n\xE3o salvas no editor n\xE3o entram no teste. Este fluxo n\xE3o tem agente: os dois modos rodam a defini\xE7\xE3o salva do fluxo." : "Altera\xE7\xF5es n\xE3o salvas no editor n\xE3o entram no teste. Salve o rascunho antes de iniciar.";
  let t5;
  if ($[7] !== t4) {
    t5 = <Alert variant="neutral" icon={t3} description={t4} />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t5) {
    t6 = <div className="mt-6 flex w-full max-w-[1160px] flex-col gap-3">{t1}{t2}{t5}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};